import { z } from '@/utils/zod'

// System permissions
export const SystemScopes = [
    'organization.read',
    'organization.billing',
    'organization.write',
    'organization.verify',
    'user.read',
    'user.write',
    'auditLog.read',
    'community.admin',
    'feedback.admin',
    'customer.report',
    'customer.report.admin',
    'customer.report.billing',
    'customer.reportType.admin',
] as const

export const SystemScopeSchema = z.enum(SystemScopes)

export type SystemScope = z.infer<typeof SystemScopeSchema>

export const SystemPermissionsSchema = z.uniqueArray(SystemScopeSchema)

export type SystemPermissions = z.infer<typeof SystemPermissionsSchema>
